module.exports = __webpack_public_path__ + "r-v3/img/ico_help_white.c78e9167.svg";